/* @ngInject */
const wagonRequest = (
  $q,
  wagonResource,
  utils,
  wagonUtils,
  valueHandler,
  wagonLabels,
  labels,
  errorHandler
) => {
  const wagonRequest = {}

  wagonRequest.getAll = async () => {
    return wagonRequest.getBySearch()
  }

  wagonRequest.getById = (_id) => {
    return $q(async (resolve, reject) => {
      if (!wagonUtils.isIdValid(_id)) {
        reject(wagonLabels.fields.id.invalid)
      }
      const functionName = 'getById'
      try {
        wagonResource.get({
          action: _id,
        }, (res) => {
          if (res && res.success) {
            resolve(res.data)
          } else if (res.message) {
            reject(res.message)
          } else if (valueHandler.isString(res)) {
            reject(res)
          } else {
            errorHandler.message(res, functionName, data)
            reject(labels.wagon.log.search.failure)
          }
        }, (error) => {
          errorHandler.status(error, functionName)
          reject(error.data.message || labels.log.failure)
        })
      } catch (error) {
        reject(error)
      }
    })
  }

  wagonRequest.getByOwner = (_ownerId) => {
    return $q(async (resolve, reject) => {
      const data = {
        ownerId: _ownerId,
      }
      try {
        const response = await wagonRequest.getBySearch(data)
        const wagons = response.wagons
        resolve(wagons)
      } catch (error) {
        reject(error)
      }
    })
  }

  wagonRequest.getByRailway = (_railwayId) => {
    return $q(async (resolve, reject) => {
      const data = {
        railwayId: _railwayId,
      }
      try {
        const response = await wagonRequest.getBySearch(data)
        const wagons = response.wagons
        resolve(wagons)
      } catch (error) {
        reject(error)
      }
    })
  }

  wagonRequest.getByTrain = (_trainId) => {
    return $q(async (resolve, reject) => {
      const data = {
        trainId: _trainId,
      }
      try {
        const response = await wagonRequest.getBySearch(data)
        resolve(response.wagons)
      } catch (error) {
        reject(error)
      }
    })
  }

  wagonRequest.getByArrivalTrain = (_arrivalTrainId) => {
    return $q(async (resolve, reject) => {
      const data = {
        arrivalTrainId: _arrivalTrainId,
      }
      try {
        const response = await wagonRequest.getBySearch(data)
        const wagons = response.wagons
        resolve(wagons)
      } catch (error) {
        reject(error)
      }
    })
  }

  wagonRequest.getInvoicable = (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.getInvoicable'

      wagonResource.post({ action: 'get-invoicable', }, _data, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            wagons: res.data,
            message: labels.wagon.log.search.success(res.data.length),
            color: res.data.length > 0 ? 'green' : 'orange',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.wagon.log.search.failure)
        }
      }, (err) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.getIncompleteId = (wagonId) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.getIncompleteId'

      wagonResource.post({ action: 'get-incomplete-id', }, { wagonId }, (res) => {
        console.log(res)
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            wagons: res.data,
            message: labels.wagon.log.search.success(res.data.length),
            color: res.data.length > 0 ? 'green' : 'orange',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.wagon.log.search.failure)
        }
      }, (err) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.getIncompleteIds = (wagonIds) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.getIncompleteIds'

      wagonResource.post({ action: 'get-incomplete-ids', }, { wagonIds }, (res) => {
        console.log(res)
        if (res && res.success && res.data) {
          resolve(res.data)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, { wagonIds })
          reject(labels.wagon.log.search.failure)
        }
      }, (err) => {
        errorHandler.status(err, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.getBySearch = async (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.getBySearch'
      const data = utils.copy(_data)
      if (valueHandler.isId(data.id) && data.id !== '') {
        if (wagonUtils.isIdValid(data.id)) {
          data.id = wagonUtils.stringToId(data.id)
        } else if (data.id.length === 12) {
          reject(wagonLabels.fields.id.invalid)
        }
      }
      wagonResource.post({
        action: 'search',
      }, { search: data }, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            wagons: res.data,
            message: labels.wagon.log.search.success(res.data.length),
            color: res.data.length > 0 ? 'green' : 'orange',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.wagon.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })

    })
  }

  wagonRequest.isTrainAlreadyUse = (_wagonId, _trainId) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.isTrainAlreadyUse'
      const data = {
        wagonId: _wagonId,
        trainId: _trainId,
      }

      wagonResource.post({
        action: 'is-train-already-used',
      }, data, (res) => {
        if (res && res.success && res.message) {
          resolve(res.message)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.wagon.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.save = (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.save'
      wagonResource.save({}, _data, (res) => {
        if (res && res.success && res.message && res.data.id) {
          const response = {
            message: res.message,
            id: res.data.id,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 23000) {
            reject(labels.wagon.log.save.duplicateWagonId)
          } else {
            errorHandler.message(res, functionName, _data)
            reject(labels.wagon.log.save.failure)
          }
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.cancelScrapping = (_wagonIds) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.cancelScrapping'
      const data = {
        wagonIds: _wagonIds,
      }

      wagonResource.post({
        action: 'cancel-scrapping',
      }, data, (res) => {
        if (res && res.success && res.message) {
          resolve(res.message)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.wagon.log.enableScrapping.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.enableScrapping = (_wagonIds, _date) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.scrap'
      const data = {
        wagonIds: _wagonIds,
        scrappingDate: _date,
      }
      wagonResource.post({
        action: 'enable-scrapping',
      }, data, (res) => {
        if (res && res.success && res.message) {
          resolve(res.message)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.wagon.log.enableScrapping.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.cancelAnnounce = (_wagonIds) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.cancelAnnounce'
      const data = {
        wagonIds: _wagonIds,
      }

      wagonResource.post({
        action: 'cancel-announce',
      }, data, (res) => {
        if (res && res.success && res.message) {
          resolve(res.message)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.wagon.log.enableScrapping.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.announceScrapping = (_wagonIds) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.announceScrapping'
      const data = {
        wagonIds: _wagonIds,
      }
      wagonResource.post({
        action: 'announce-scrapping',
      }, data, (res) => {
        if (res && res.success && res.message) {
          resolve(res.message)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.wagon.log.enableScrapping.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }



  wagonRequest.scrap = (_id, _scrapped) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.scrap'
      const data = {
        id: _id,
        scrapped: _scrapped,
      }
      wagonResource.post({
        action: 'scrap',
      }, data, (res) => {
        if (res && res.success && res.message) {
          resolve(res.message)
        } else if (res && res.code === 0) {
          reject(labels.wagon.log.scrap.alreadyScrapped)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.wagon.log.scrap.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.modifyPosition = (_wagonIds, _railwayId) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.modifyPosition'
      const data = {
        wagonIds: _wagonIds,
        railwayId: _railwayId,
      }
      wagonResource.post({
        action: 'modify-position',
      }, data, (res) => {
        if (res && res.success && res.message) {
          resolve(res.message)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.wagon.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.update = (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.update'

      console.log('update', _data)

      wagonResource.update({ action: _data.id }, _data, (res) => {
        if (res && res.success && res.message && res.data) {
          const response = {
            message: res.message,
            wagon: res.data,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.wagon.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.updateField = (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.updateField'

      wagonResource.update({
        action: 'update-field',
      }, _data, (res) => {
        if (res && res.success && res.message && res.data) {
          const response = {
            message: res.message,
            wagon: res.data,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.wagon.log.updateField.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.updateOwner = (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.updateOwner'

      wagonResource.update({
        action: 'update-owner',
      }, _data, (res) => {
        if (res && res.success && res.message && res.data) {
          const response = {
            message: res.message,
            wagon: res.data,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.wagon.log.updateField.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.updateSale = (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.updateSale'

      wagonResource.update({
        action: 'update-sale',
      }, _data, (res) => {
        if (res && res.success && res.message && res.data) {
          const response = {
            message: res.message,
            wagon: res.data,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.wagon.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.delete = (_id) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.delete'
      const data = {
        id: _id,
      }
      wagonResource.delete({ action: _id }, (res) => {
        if (res && res.success && res.message) {
          const response = {
            message: res.message,
            color: 'green',
            id: _id,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 2) {
            reject(labels.wagon.log.delete.onRailway)
          } else {
            errorHandler.message(res, functionName, data)
            reject(labels.wagon.log.delete.failure)
          }
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.move = (_wagonIds, _railwayId, _sens) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.move'
      const data = {
        wagonIds: _wagonIds,
        railwayId: _railwayId,
        sens: _sens,
      }
      wagonResource.post({
        action: 'move',
      }, data, (res) => {
        if (res && res.message) {
          resolve(res.message || res.data)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.wagon.log.move.failure)
        }
      }, (error) => {
        console.log(error)
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.park = (_wagonIds, _railwayId, _trainId, _sens) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.park'
      const data = {
        wagonIds: _wagonIds,
        railwayId: _railwayId,
        trainId: _trainId,
        sens: _sens,
      }
      wagonResource.post({ action: 'park' }, data, (res) => {
        if (res && res.success && res.message) {
          resolve(res.message)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.wagon.log.park.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.unpark = (_wagonIds, _trainId) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.unpark'
      const data = {
        wagonIds: _wagonIds,
        trainId: _trainId,
      }
      wagonResource.post({
        action: 'unpark',
      }, data, (res) => {
        if (res && res.success && res.message) {
          resolve(res.message)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          console.log(res)
          errorHandler.message(res, functionName, data)
          if (res.code === 2) {
            reject(labels.wagon.log.unpark.alreadyAssigned)
          } else {
            reject(labels.wagon.log.unpark.failure)
          }
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.registerOrUpdate = (_wagon) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.registerOrUpdate'

      wagonResource.post({
        action: 'register-or-update',
      }, _wagon, (res) => {
        if (res && res.success && res.message) {
          resolve(res.message)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _wagon)
          reject(labels.wagon.log.save.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.removeFromTrain = (_wagonId, _trainId) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.removeFromTrain'
      const data = {
        wagonId: _wagonId,
        trainId: _trainId,
      }
      wagonResource.post({
        action: 'remove-from-train',
      }, data, (res) => {
        if (res && res.success && res.message) {
          resolve(res.message)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.wagon.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.addNewDisposition = (_disposition, _wagonId) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.addNewDisposition'
      const data = {
        disposition: _disposition,
        wagonId: _wagonId,
      }

      wagonResource.post({
        action: 'add-new-disposition',
      }, data, (res) => {
        if (valueHandler.isObject(res) && res.success) {
          const response = {
            message: 'Nouvelle disposition ajoutée',
            color: 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.wagon.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.checkScrapping = (_wagonId, _isChecked) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.checkScrapping'
      const data = {
        wagonId: _wagonId,
        isChecked: _isChecked,
      }

      wagonResource.post({
        action: 'check-scrapping',
      }, data, (res) => {
        if (valueHandler.isObject(res) && res.success) {
          const response = {
            message: wagonLabels.log.checkScrapping.success(_isChecked),
            color: 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.wagon.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.getPerPage = (data) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.getPerPage'

      wagonResource.post({
        action: 'get-per-page',
      }, data, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            wagons: res.data,
            message: 'Tout bon',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.wagon.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.renameWagon = (_wagonId) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.renameWagon'
      const data = {
        wagonId: _wagonId,
      }

      wagonResource.post({
        action: 'rename',
      }, data, (res) => {
        if (valueHandler.isObject(res) && res.success) {
          const response = {
            message: wagonLabels.log.renameWagon.success,
            color: 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.wagon.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  wagonRequest.removeLastDisposition = (_wagonIds) => {
    return $q((resolve, reject) => {
      const functionName = '$$wagon.removeLastDisposition'
      const data = {
        wagonIds: _wagonIds,
      }

      wagonResource.post({
        action: 'remove-last-disposition',
      }, data, (res) => {
        if (valueHandler.isObject(res) && res.success) {
          const response = {
            message: wagonLabels.log.removeLastDisposition.success,
            color: 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.wagon.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  return wagonRequest
}

export default wagonRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/services/request.service.js